<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ leaveApproverInit.employee_code }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ leaveApproverInit.firstname_th }}
              {{ leaveApproverInit.lastname_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <div>
          <label class="body-2">ผู้อนุมัติคนที่ 1</label>
          <v-text-field
            class="fix-google-chrome mt-1"
            readonly
            :value="
              leaveApprover.approver_employee &&
              leaveApprover.approver_employee['1']
                ? `${leaveApprover.approver_employee['1'].firstname_th} ${leaveApprover.approver_employee['1'].lastname_th}`
                : ''
            "
            outlined
            dense
          >
            <template v-slot:append>
              <v-btn
                v-if="
                  leaveApprover.approver_employee &&
                  leaveApprover.approver_employee['1']
                "
                class="mb-2"
                icon
                @click="handleDeleteLeaveApprover('1')"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn class="mb-2" icon @click="handleEditLeaveApprover('1')">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </div>
        <div>
          <label class="body-2"> ผู้อนุมัติคนที่ 2 </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            readonly
            :value="
              leaveApprover.approver_employee &&
              leaveApprover.approver_employee['2']
                ? `${leaveApprover.approver_employee['2'].firstname_th} ${leaveApprover.approver_employee['2'].lastname_th}`
                : ''
            "
            outlined
            dense
          >
            <template v-slot:append>
              <v-btn
                v-if="
                  leaveApprover.approver_employee &&
                  leaveApprover.approver_employee['2']
                "
                class="mb-2"
                icon
                @click="handleDeleteLeaveApprover('2')"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn class="mb-2" icon @click="handleEditLeaveApprover('2')">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </div>
        <div>
          <label class="body-2"> ผู้อนุมัติคนที่ 3 </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            readonly
            :value="
              leaveApprover.approver_employee &&
              leaveApprover.approver_employee['3']
                ? `${leaveApprover.approver_employee['3'].firstname_th} ${leaveApprover.approver_employee['3'].lastname_th}`
                : ''
            "
            outlined
            dense
          >
            <template v-slot:append>
              <v-btn
                v-if="
                  leaveApprover.approver_employee &&
                  leaveApprover.approver_employee['3']
                "
                class="mb-2"
                icon
                @click="handleDeleteLeaveApprover('3')"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn class="mb-2" icon @click="handleEditLeaveApprover('3')">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn
            class="primary mr-3"
            depressed
            :disabled="
              !isLeaveApproverDataChange ||
              (uiCtrl && !uiCtrl.isEnable('btn:::leave_approver:update'))
            "
            @click="onSave"
            >บันทึก</v-btn
          >
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <EmployeeListDialog
      :dialog="employeeListDialog"
      @cancelEmployeeListDialog="cancelEmployeeListDialog"
      @submitEmployeeListDialog="submitEmployeeListDialog"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EmployeeListDialog from '@/components/EmployeeListDialog.vue'

export default {
  components: {
    ConfirmDialog,
    EmployeeListDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    leaveApprover: {
      type: Object,
    },
    leaveApproverInit: {
      type: Object,
    },
  },
  data() {
    return {
      dialogForbidden: false,
      employeeListDialog: false,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      leaveApproverLevel: 1,
      leaveApprovers: [],
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isLeaveApproverDataChange() {
      if (
        this.leaveApprover?.approver_employee?.['1']?.approver_employee_code !==
          this.leaveApproverInit?.approver_employee?.['1']
            ?.approver_employee_code ||
        this.leaveApprover?.approver_employee?.['2']?.approver_employee_code !==
          this.leaveApproverInit?.approver_employee?.['2']
            ?.approver_employee_code ||
        this.leaveApprover?.approver_employee?.['3']?.approver_employee_code !==
          this.leaveApproverInit?.approver_employee?.['3']
            ?.approver_employee_code
      ) {
        this.$emit('isLeaveApproverDataChange', true)
        return true
      }
      this.$emit('isLeaveApproverDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      editLeaveApproverEmployees: 'leaveApprover/editLeaveApproverEmployees',
    }),
    handleDeleteLeaveApprover(level) {
      this.$emit('onChangeApproverEmployee', {
        type: 'delete',
        approverEmployee: { ...this.leaveApprover.approver_employee[level] },
      })
    },
    handleEditLeaveApprover(level) {
      this.employeeListDialog = true
      this.leaveApproverLevel = Number(level)
    },
    cancelEmployeeListDialog() {
      this.employeeListDialog = false
    },
    submitEmployeeListDialog(selectedItems) {
      const approverEmployee = {
        approver_employee_uuid: selectedItems[0].employee_uuid,
        approver_employee_code: selectedItems[0].employee_code,
        approver_level: this.leaveApproverLevel,
        firstname_en: selectedItems[0].firstname_en,
        firstname_th: selectedItems[0].firstname_th,
        lastname_en: selectedItems[0].lastname_en,
        lastname_th: selectedItems[0].lastname_th,
      }

      this.$emit('onChangeApproverEmployee', { type: 'edit', approverEmployee })

      this.employeeListDialog = false
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_uuid: this.leaveApprover.employee_uuid,
          body: {
            approver_employee: Object.values(
              this.leaveApprover.approver_employee
            ),
          },
        }

        this.editLeaveApproverEmployees(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            if (error.response && error.response.status === 403) {
              this.dialogForbidden = true
              return
            }

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isLeaveApproverDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
    },
    onReset() {
      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
      // if (this.formAction === 'add' || this.formAction === '') {
      //   this.$refs.form.reset()
      // } else {
      //   this.$emit('onReset', this.formAction)
      // }
    },
  },
}
</script>
